import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from './base-query';

const damageAPI = createApi({
    reducerPath: "damageAPI",
    baseQuery,
    endpoints: (builder) => ({
        getAllDamagedItems: builder.mutation({
            query: ({ page, size, key }) => {
                let apiUrl = `admin/damage-entry?page=${page}&limit=${size}`;

                if (key) {
                    apiUrl += `&search=${key}`;
                }

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["damages"],
        }),
        deleteDamagedItem: builder.mutation({
            query: ({ id }) => {
                return {
                    url: `admin/damage-entry/${id}`,
                    method: "DELETE"
                };
            },
            invalidatesTags: ["damages"],
        }),

        markAsDamagedItem: builder.mutation({
            query: ({ productId, data }) => {
                return {
                    url: `admin/product/${productId}/damage-entry`,
                    method: "POST",
                    body: data
                };
            },
            invalidatesTags: ["damages"],
        }),
    })
});

export const { 
    useGetAllDamagedItemsMutation,
    useDeleteDamagedItemMutation,
    useMarkAsDamagedItemMutation
} = damageAPI;

export default damageAPI;